import $store from '@/store/index'
import Api from '@/util/api'
import Apis from '@/util/apis'
import SlimApi from '@/util/slimapi'
import SlimApis from '@/util/slimapis'
import Constants from '@/util/constants'
import Data from '@/util/data'
import Decimal from 'decimal.js'
import global from '@/util/global'
import Vue from 'vue'
import { sha256 } from 'js-sha256'
import util from '@/util/util'
import $router from '@/router/index'

export default {
  returnDecimalValue (decimalStr) {
    let decimalValue = new Decimal(0)
    if (decimalStr !== '' && decimalStr !== null) {
      decimalValue = new Decimal(decimalStr)
    }
    return decimalValue
  },
  returnOrdSubmittedQtyPrice (trade) {
    if (trade.so && trade.so.length > 0) {
      return { qty: this.returnDecimalValue(trade.so[0].Qty), price: this.returnDecimalValue(trade.so[0].Price) }
    } else {
      return { qty: new Decimal(0), price: new Decimal(0) }
    }
  },
  returnAverageTradePrice (trade) {
    let tradePrice = new Decimal(trade.Price)
    if (trade.so && trade.so.length > 0) {
      let totQty = new Decimal(0)
      let totAmount = new Decimal(0)
      if (trade.Status !== 'ORDSUBMIT' && trade.Status !== 'COND') {
        totQty = new Decimal(trade.Qty)
        totAmount = tradePrice.mul(trade.Qty)
      }
      trade.so.forEach(so => {
        if (so.Status !== 'EXC') {
          const soQty = this.returnDecimalValue(so.Qty)
          const soPrice = this.returnDecimalValue(so.Price)
          totQty = totQty.add(soQty)
          const amount = soPrice.mul(soQty)
          totAmount = totAmount.add(amount)
        }
      })
      if (totAmount.equals(0) || totQty.equals(0)) {
        tradePrice = new Decimal(0)
      } else {
        tradePrice = totAmount.div(totQty)
      }
    }
    // console.log(tradePrice.toString())
    return tradePrice
  },
  cancelSOInDB (so, line) {
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/safety/delete', {
      params: {
        id: so.Id,
        token: $store.state.sys.token,
        trid: so.TradeId
      }
    }).then(function (response) {
      if (!response.data.err) {
        line.remove()
        global.viewModeLines = global.viewModeLines.filter(line1 => line1 !== line)
        Data.vm.$Notice.success({
          title: Data.vm.$text.tr('Ордер успешно отменен'),
          duration: 6
        })
      } else {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: util.returnTextForErr(response.data.err),
          duration: 10
        })
        // disabled
        // $store.dispatch('updateExchangesAsync')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  sortEditedTradeSO () {
    // console.log('sortEditedTradeSO')
    if ($store.state.trade.editTrade.so && $store.state.trade.editTrade.so.length > 1) {
      let k = 1
      if ($store.state.trade.editTrade.Side === 'B') {
        k = -1
      }
      $store.state.trade.editTrade.so.sort((a, b) => {
        if (a.Status < b.Status) {
          return 1
        } else if (a.Status > b.Status) {
          return -1
        } else {
          return parseFloat(a.Price) >= parseFloat(b.Price) ? 1 * k : -1 * k
        }
      })
    }
  },
  cancelSO (so) {
    const trade = $store.state.trade.editTrade
    if (trade) {
      trade.so = trade.so.filter(so1 => so1 !== so)
    }
  },
  getMargin ({ symbol, side }) {
    const params = {
      token: $store.state.sys.token,
      etid: $store.state.sys.tradeExchange.Id,
      s: symbol,
      margin: $store.state.trade.marginType,
      side: side || $store.state.trade.side
    }

    return Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('margin/get', { params })
      .then((response) => {
        if (response.data && response.data.err) {
          // this.showError(response.data.err)
        }

        return response
      })
      .catch((error) => {
        console.log(error)
        if (error && error.message === 'Request failed with status code 401') {
          // return
        }

        // this.showError(error)
      })
  },
  setMargin ({ marginType, leverage, src, symbol, side }) {
    const params = {
      token: $store.state.sys.token,
      etid: $store.state.sys.tradeExchange.Id,
      s: symbol || $store.state.trade.symbol,
      side: side || $store.state.trade.side,
      lev: leverage || $store.state.trade.leverage,
      type: marginType || $store.state.trade.marginType,
      src
    }

    return Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('margin/set', { params })
      .then((response) => {
        if (response.data && response.data.err) {
          switch (response.data.err) {
            case 'request error: Margin type cannot be changed if there exists open orders.':
              response.data.err = Data.vm.$text.tr(
                'По данной паре есть открытая позиция или ордера, поэтому тип маржи не может быть изменен'
              )
              break
            case 'request error: Leverage is smaller than permitted: insufficient margin balance.':
              response.data.err = Data.vm.$text.tr(
                'Для уменьшения плеча недостаточно свободного баланса'
              )
              break
            case 'can\'t change leverage with open orders':
              response.data.err = Data.vm.$text.tr(
                'У вас есть открытые ордера. Отмените их перед изменением кредитного плеча.'
              )
              break
          }

          this.showError(response.data.err)
        }

        return response
      })
      .catch((error) => {
        this.showError(error)
      })
  },
  showError (desc) {
    Data.vm.$Notice.error({
      title: Data.vm.$text.tr('Ошибка'),
      desc,
      duration: 10
    })
  },
  addNewSO () {
    if ($store.state.trade.editTrade) {
      const filt = $store.state.data.symbolsfilter[$store.state.trade.editTrade.Symbol]
      let priceDec = 8
      let amountDec = 8
      let qtyDec = 8
      if (filt) {
        qtyDec = filt.QtyDec
        priceDec = filt.PriceDec
        amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
      }
      const mult = $store.state.trade.editTrade.Side === 'S' ? 1.01 : 0.99
      let executedSoQty = $store.state.trade.editTrade.Qty
      if ($store.state.trade.editTrade.Status !== 'ORDSUBMIT' && $store.state.trade.editTrade.Status !== 'COND') {
        executedSoQty = $store.state.trade.editTrade.so.reduce((accum, item) => {
          if (item.Status === 'EXC') {
            return accum + +item.Qty
          } else {
            return accum
          }
        }, 0)
      }
      let price = new Decimal($store.state.sys.lastPrice).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString()
      if ($store.state.trade.editTrade.ExchId === 'BYF') {
        price = new Decimal($store.state.sys.lastPrice).dividedToIntegerBy(filt.PriceMin).mul(filt.PriceMin).toDP(priceDec, Decimal.ROUND_DOWN).toString()
      }

      const so = {
        Price: price,
        Pct: new Decimal(100),
        Qty: new Decimal(executedSoQty).toDP(qtyDec, Decimal.ROUND_DOWN).toString(),
        Status: 'ACT',
        Trigger: '0',
        TrailPct: '0',
        Option: 'EMPTY'
      }

      so.Amount = new Decimal(so.Price).mul(so.Qty).toDP(amountDec, Decimal.ROUND_DOWN).toString()
      let sos = []
      if ($store.state.trade.editTrade.so) {
        sos = $store.state.trade.editTrade.so
      }
      sos.push(so)
      Vue.set($store.state.trade.editTrade, 'so', sos)
    }
  },
  cancelTradeOnTV (tradeId, line) {
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/action', {
      params: {
        id: 'close',
        token: $store.state.sys.token,
        trid: tradeId
      }
    }).then(function (response) {
      $store.state.confirmActionModal.show = false
      if (!response.data.err) {
        // console.log('bef', global.viewModeLines.length)
        global.viewModeLines = global.viewModeLines.filter((obj) => obj !== line)
        // console.log('aft', global.viewModeLines.length)
        line.remove()

        $store.state.sys.lastTrade = Date.now()
        Data.vm.$Notice.success({
          title: Data.vm.$text.tr('Сделка успешно отменена'),
          duration: 6
        })
        $store.dispatch('updateAssets')
      } else {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: util.returnTextForErr(response.data.err),
          duration: 10
        })
        // disabled
        // $store.dispatch('updateExchangesAsync')
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  cancelOrCloseTrade (tradeId, status) {
    let act2 = ' отменена'
    if (status !== 'ORDSUBMIT' && status !== 'COND') {
      act2 = ' выключена'
    }
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/action', {
      params: {
        id: 'close',
        token: $store.state.sys.token,
        trid: tradeId
      }
    }).then(function (response) {
      $store.state.confirmActionModal.show = false
      if (!response.data.err) {
        $store.state.sys.lastTrade = Date.now()
        Data.vm.$Notice.success({
          title: Data.vm.$text.tr('Сделка успешно' + act2),
          duration: 6
        })
        $store.dispatch('updateAssets')
        if ($store.state.trade.editTrade) {
          $store.state.trade.editTradeId = null
          $store.state.trade.editTrade = null
        }
      } else {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: util.returnTextForErr(response.data.err),
          duration: 10
        })
        // disabled
        // if (act2 === ' отменена') {
        //   $store.dispatch('updateExchangesAsync')
        // }
      }
    }).catch(function (error) {
      console.log(error)
    })
  },
  panicSell (tradeId, actionId) {
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/action', {
      params: {
        id: actionId,
        token: $store.state.sys.token,
        trid: tradeId
      }
    }).then(function (response) {
      $store.state.confirmActionModal.show = false
      if (!response.data.err) {
        Data.vm.$Notice.success({
          title: Data.vm.$text.tr('Приказ выполнен'),
          duration: 6
        })
        if ($store.state.trade.editTrade) {
          $store.state.trade.editTradeId = null
          $store.state.trade.editTrade = null
        }
      } else {
        Data.vm.$Notice.error({
          title: Data.vm.$text.tr('Ошибка'),
          desc: util.returnTextForErr(response.data.err),
          duration: 10
        })
        // disabled
        // $store.dispatch('updateExchangesAsync')
      }
      $store.state.sys.lastTrade = Date.now()
    }).catch(function (error) {
      console.log(error)
    })
  },
  numOfExecutedSteps (tpsteps) {
    if (!tpsteps) {
      return 0
    }
    return tpsteps.reduce((sum, current) => {
      if (current.Status === 'EXC') {
        return sum + 1
      } else {
        return sum
      }
    }, 0)
  },
  tradeGetAndUpdate (tradeId) {
    // console.log('route:', $router.currentRoute.name)
    if ($router.currentRoute.name !== 'terminal') {
      return
    }
    this.tradeGet(tradeId).then(response => {
      if (response.status === Constants.http.OK) {
        const oldTrade = $store.state.trade.editTrade
        if (response.data.so) {
          this.addAmountToSo(response.data.so)
        }
        const newTrade = response.data

        // console.log('tradeGetAndUpdate: ', newTrade, 'old:', oldTrade)

        if (oldTrade && oldTrade.Status === 'ORDSUBMIT' && newTrade.Status === 'SLTP') {
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr('Ордер исполнен'),
            duration: 10
          })
          $store.state.trade.editTrade = newTrade
          return
        }

        if (oldTrade && oldTrade.Status === 'COND' && newTrade.Status === 'SLTP') {
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr('Отложенный ордер исполнен'),
            duration: 10
          })
          $store.state.trade.editTrade = newTrade
          return
        }

        if (newTrade.Status === 'ORDCANCEL' || newTrade.Status === 'CLOSED') {
          $store.state.trade.editTrade = null
          return
        }

        if (newTrade.Status === 'ERROR') {
          Data.vm.$Notice.error({
            title: Data.vm.$text.tr('Сделка закрыта с ошибкой'),
            duration: 10
          })
          $store.state.trade.editTrade = null
          return
        }

        if (newTrade.Status !== 'ORDSUBMIT' && newTrade.Status !== 'SLTP' && newTrade.Status !== 'COND') {
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr('Сделка выполнилась'),
            duration: 10
          })
          $store.state.trade.editTrade = null
          return
        }

        if (newTrade.Sltp && newTrade.Sltp.Status === 'TPT' && (!oldTrade.Sltp || oldTrade.Sltp.Status !== 'TPT')) {
          if (oldTrade.Sltp && oldTrade.Sltp.Status === 'NEW') {
            // dont trigger on new stop loss by trailing
          } else {
            Data.vm.$Notice.success({
              title: Data.vm.$text.tr('TP Trailing активирован'),
              duration: 10
            })
            if (response.data.Sltp && response.data.Sltp.SlPrice !== '0') {
              $store.state.trade.slAdded = true
            }
            $store.state.trade.editTrade = newTrade
            return
          }
        }

        // if (newTrade.Sltp && newTrade.Sltp.Status === 'TPT' && oldTrade.Sltp && oldTrade.Sltp.Status === 'TPT' && parseFloat(newTrade.Sltp.SlPrice) !== parseFloat(oldTrade.Sltp.SlPrice)) {
        //   $store.state.trade.editTrade.Sltp.SlPrice = newTrade.Sltp.SlPrice
        //   // console.log('sl price changed', $store.state.trade.editTrade.Sltp.SlPrice)
        // }

        if (this.numOfExecutedSteps(oldTrade.Tpsteps) !== this.numOfExecutedSteps(newTrade.Tpsteps)) {
          console.log('old tpsteps:', oldTrade.Tpsteps)
          console.log('new tpsteps:', newTrade.Tpsteps)
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr('Take Profit выполнен'),
            duration: 10
          })
          $store.state.trade.editTrade = newTrade
          return
        }

        // if (oldTrade.Sltp && newTrade.Sltp && oldTrade.Sltp.Updated !== newTrade.Sltp.Updated) {
        //   Data.vm.$Notice.success({
        //     title: 'Сделка обновлена',
        //     duration: 6
        //   })
        //   $store.state.trade.editTrade = newTrade
        //   return
        // }

        let curStep = 0
        if (oldTrade.tpsteps) {
          oldTrade.tpsteps.forEach((step) => {
            if (step.Status === 'EXC') {
              curStep += 1
            }
          })
          // console.log('old curStep:', curStep)
        }

        if (oldTrade.tpsteps && newTrade.Sltp && newTrade.Sltp.Steps &&
          curStep !== newTrade.Sltp.Steps.CurStep) {
          // console.log('123:', curStep, newTrade.Sltp.Steps.CurStep)
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr('Ступень TP выполнилась'),
            duration: 10
          })
          $store.state.trade.editTrade = newTrade
          return
        }

        oldTrade.Profit = newTrade.Profit
        oldTrade.ProfitPct = newTrade.ProfitPct
        oldTrade.Qty = newTrade.Qty
        oldTrade.Amount = newTrade.Amount
        oldTrade.Upnl = newTrade.Upnl

        if (newTrade.Sltp) {
          !oldTrade.Sltp && (oldTrade.Sltp = {})
          oldTrade.Sltp.SlTrailPct = newTrade.Sltp.SlTrailPct
        }

        let side = 'Покупка'
        if (newTrade.Side === 'S') {
          side = 'Продажа'
        }
        // усреднения
        if (this.numOfExecutedSteps(oldTrade.so) !== this.numOfExecutedSteps(newTrade.so)) {
          // console.log('old SOs:', oldTrade.so)
          // console.log('new SOs:', newTrade.so)
          Data.vm.$Notice.success({
            title: Data.vm.$text.tr(side + ' исполнена'),
            duration: 10
          })
          $store.state.trade.editTrade = newTrade
        }

        // изменилась цена усреднения c trailing
        if (response.data.so) {
          for (let i = 0; i < response.data.so.length; i++) {
            const newso = response.data.so[i]
            // console.log('new so', newso)
            if (parseFloat(newso.TrailPct) > 0 && newso.Status === 'ACT') {
              for (let y = 0; y < $store.state.trade.editTrade.so.length; y++) {
                const oldso = $store.state.trade.editTrade.so[y]
                if (oldso.Id === newso.Id) {
                  // console.log('old so', oldso)
                  if (newso.Trail && newso.Trail === oldso.Trail && parseFloat(oldso.Price) !== parseFloat(newso.Price)) {
                    $store.state.trade.editTrade.so.splice(y, 1, newso)
                    // console.log('editTrade.so price', $store.state.trade.editTrade.so[y])
                    // console.log('editTrade', $store.state.trade.editTrade)
                  }
                  if (newso.Trail !== oldso.Trail) {
                    $store.state.trade.editTrade.so.splice(y, 1, newso)
                    Data.vm.$Notice.success({
                      title: Data.vm.$text.tr('Trailing активирован'),
                      duration: 10
                    })
                    // console.log('editTrade.so activated', $store.state.trade.editTrade.so[y])
                    // console.log('editTrade', $store.state.trade.editTrade)
                  }
                }
              }
            }
          }
        }

        // изменилась цена ликвидации
        if (oldTrade.Info && newTrade.Info && oldTrade.Info.LiquidationPrice !== newTrade.Info.LiquidationPrice) {
          $store.state.trade.editTrade.Info.LiquidationPrice = newTrade.Info.LiquidationPrice
        }
        // $store.state.trade.editTrade = response.data
      } else {
        console.log('http error. status: ', status)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  tradeGetAndSet (tradeId) {
    this.tradeGet(tradeId).then(response => {
      if (response.status === Constants.http.OK) {
        // console.log('tradeGetAndSet: ', response.data)
        // для редактирования отложенного ордера
        if (response.data.Status === 'COND') {
          response.data.so = [{ Price: response.data.Price, Qty: response.data.Qty, Status: 'ACT', Cond: true }]
        }
        if (response.data.so) {
          this.addAmountToSo(response.data.so)
        }
        if ((response.data.Sltp && response.data.Sltp.SlPrice !== '0') || (response.data.Status === 'ORDSUBMIT' && response.data.Info && response.data.Info.SlPct !== '0')) {
          $store.state.trade.slAdded = true
        } else {
          $store.state.trade.slAdded = false
        }
        $store.state.trade.editTrade = response.data
      } else {
        console.log('http error. status: ', status)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  addAmountToSo (soArr) {
    const filt = $store.state.data.symbolsfilter[$store.state.trade.symbol]
    let amountDec = 8
    if (filt) {
      amountDec = parseFloat(filt.PriceDec) + parseFloat(filt.QtyDec)
    }
    for (let i = 0; i < soArr.length; i++) {
      soArr[i].Amount = new Decimal(soArr[i].Qty).mul(soArr[i].Price).toDP(amountDec, Decimal.ROUND_DOWN).toString()
      if (soArr[i].TrailPct !== '0') {
        soArr[i].Option = 'TRAILING'
      } else if (soArr[i].Trigger !== '0') {
        soArr[i].Option = 'TRIGGER'
      } else {
        soArr[i].Option = 'EMPTY'
      }
    }
  },
  tradeGet (tradeId) {
    return SlimApis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/get', {
      params: {
        token: $store.state.sys.token,
        tid: tradeId
      }
    })
  },
  terminalRefreshToken () {
    Api.get('user/refresh', {
      params: {
        token: $store.state.sys.token
      }
    }).then(response => {
      if (response.status === Constants.http.OK) {
        $store.state.sys.token = response.data.tkn
        localStorage.setItem('token', response.data.tkn)
        // console.log('token refreshed: ', $store.state.sys.token)
      } else {
        console.log('error. status: ', status)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  async terminalAuth (pwdtoken, code, devtkn) {
    const x = sha256('V1c5QraZkYkA' + pwdtoken).substr(0, 6)
    return Api.get('auth', {
      params: {
        token: pwdtoken,
        code,
        devtkn,
        x
      }
    })
  },
  async terminalAuthDevcode (pwdtoken, devcode, code) {
    const x = sha256('V1c5QraZkYkA' + pwdtoken).substr(0, 6)
    return Api.get('auth', {
      params: {
        token: pwdtoken,
        devcode,
        code,
        x
      }
    })
  },
  async auth2 (pwdtoken) {
    try {
      const response = await Api.get('auth', {
        params: {
          token: pwdtoken
        }
      })
      if (response.status === Constants.http.OK) {
        // console.log('ok. data: ', response.data)
        return response.data
      } else {
        console.log('error. status: ', response.status)
      }
    } catch (error) {
      console.log(error)
    }
  },
  async addDemoExch (name) {
    try {
      const response = await Api.get('user/add_demo', {
        params: {
          token: $store.state.sys.token,
          name
        }
      })
      if (response.status === Constants.http.OK) {
        // console.log('ok. data: ', response.data)
        if (response.data.err) {
          return response.data.err
        }
      } else {
        console.log('error. status: ', response.status)
      }
    } catch (error) {
      console.log(error)
    }
  },
  updateRates () {
    Api.get('sys/rates', {
      params: {
        token: $store.state.sys.token
      }
    }).then(response => {
      if (response.status === Constants.http.OK) {
        $store.state.sys.rates.btc = response.data['BTC/USD']
        $store.state.sys.rates.eth = response.data['ETH/USD']
      } else {
        console.log('error. status: ', status)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  panicSellAsset (symbol, qty, vm) {
    // var symbol = coin + '_BTC'
    // if (!confirm('Продать ' + coin + ' на BTC по рынку?')) {
    //   return
    // }
    // console.log('panicSellAsset', symbol, qty)
    Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('asset/sell?token=' + $store.state.sys.token + '&etid=' + $store.state.sys.tradeExchange.Id + '&symbol=' + symbol + '&qty=' + qty)
      .then(function (response) {
        if (!response.data.err) {
          $store.state.sys.lastTrade = Date.now()
          vm.$Notice.success({
            title: vm.$text.tr('Продажа исполнена'),
            duration: 10
          })
        } else {
          // console.log(response.data.err)
          vm.$Notice.error({
            title: vm.$text.tr('Ошибка'),
            desc: util.returnTextForErr(response.data.err),
            duration: 10
          })
          // disabled
          // vm.$store.dispatch('updateExchangesAsync')
        }
      })
      .catch(function (error) {
        console.log(error)
      })
  },
  ApiCreateTrade (vm) {
    // '&etid=' + $store.state.sys.tradeExchange.Id +
    // '&symbol=' + $store.state.trade.symbol +
    // '&side=' + $store.state.trade.side +
    // '&otype=' + $store.state.trade.type +
    // '&price=' + $store.state.trade.price +
    // '&qty=' + $store.state.trade.qty +
    // '&sl_price=' + $store.state.trade.slprice +
    // '&tp_price=' + $store.state.trade.tpprice +
    // '&sl_trail_pct=' + $store.state.trade.sltrail +
    // '&tp_trail_pct=' + $store.state.trade.tptrail +
    // '&tp_steps=' + $store.state.trade.tpsteps // todo format

    let stepsEncoded = ''

    $store.state.trade.tpsteps.forEach(step => {
      // stepsEncoded += step.Price + ':' + step.Pct + ':' + step.Qty + ':' + step.Status + ','
      stepsEncoded += ':false:' + step.Price + ':' + step.Pct + ':' + step.Qty + ':ACT,'
    })

    if ($store.state.trade.tpprice && $store.state.trade.tpsteps.length === 0) {
      stepsEncoded = ':false:' + $store.state.trade.tpprice + ':100:' + new Decimal($store.state.trade.qty).toString() + ':ACT'
    }

    const params = {
      token: $store.state.sys.token,
      etid: $store.state.sys.tradeExchange.Id,
      symbol: $store.state.trade.symbol,
      side: $store.state.trade.side,
      otype: $store.state.trade.type,
      price: $store.state.trade.price,
      qty: new Decimal($store.state.trade.qty).toString(),
      sl_price: $store.state.trade.slprice,
      tp_price: $store.state.trade.tpprice,
      sl_trail_pct: $store.state.trade.sltrail,
      tp_trail_pct: $store.state.trade.tptrail,
      cmnt: $store.state.trade.comment,
      tp_steps: stepsEncoded
    }

    if ($store.getters.isFutures) {
      params.leverage = $store.state.trade.leverage
    }

    if ($store.getters.isOKXFutures || $store.getters.isBYF || $store.getters.isBitgetFutures) {
      params.type = $store.state.trade.marginType
    }

    if ($store.state.trade.type === 'cond') {
      params.direction = $store.state.trade.direction
      // console.log('direction:', params.dir)
    }

    SlimApis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('trade/create', {
      params
    }).then(response => {
      if (response.status === Constants.http.OK) {
        if (response.data.err) {
          // console.log('create trade err: ', response.data.err)
          if (response.data.err === 'request error: Order\'s position side does not match user\'s setting.') {
            vm.$Notice.error({
              title: vm.$text.tr('Ошибка'),
              desc: vm.$text.tr('HedgeError'),
              duration: 15
            })
            return
          } else if (response.data.err === 'operation is not supported under the current account mode') {
            const link = vm.$text.tr(
              'https://doc.capico.app/v/ru/ex/use/okx'
            )
            vm.$Notice.error({
              title: vm.$text.tr('Ошибка'),
              desc: vm.$text.tr(
                'Включите маржинальный режим аккаунта на бирже.'
              ) +
                ' <a href="' +
                link +
                '"style="color: var(--color-info)" target="_blank">' +
                vm.$text.tr('Подробнее') +
                '<a>',
              duration: 15
            })
            return
          }
          vm.$Notice.error({
            title: vm.$text.tr('Ошибка'),
            desc: util.returnTextForErr(response.data.err),
            duration: 15
          })
          // disabled
          // vm.$store.dispatch('updateExchangesAsync')
        } else {
          // ref.$store.dispatch('updateOpenOrders')
          setTimeout(() => {
            $store.dispatch('updateAssetBalance', true)
          }, 200)
          // ref.$Message.info('Приказ успешно создан')
          vm.$Notice.success({
            title: vm.$text.tr('Сделка создана'),
            duration: 10
          })
          $store.state.sys.lastTrade = Date.now()
          $store.state.trade.slprice = ''
          $store.state.trade.tpprice = ''
          $store.state.trade.sltrail = ''
          $store.state.trade.tptrail = ''
          $store.state.trade.tpsteps = []
        }
      } else {
        console.log('NOT OK: ' + response.status)
      }
    }).catch(error => {
      vm.$Notice.error({
        title: vm.$text.tr('Ошибка'),
        desc: util.returnTextForErr(error),
        duration: 15
      })
      console.log(error)
    })
  },
  usdbtcValue (asset, field) {
    let res = ''
    if ($store.state.sys.usdbtc === 'USD') {
      res += '$'
    }
    res += asset[field][$store.state.sys.usdbtc.substr(0, 1)]
    if ($store.state.sys.usdbtc === 'BTC') {
      res += ' BTC'
    }
    return res
  },
  updateExchValue () {
    if ($store.state.sys.exchanges.length === 0) {
      return
    }
    const params = {
      params: {
        token: $store.state.sys.token,
        demo: $store.state.sys.demo ? '1' : '0'
      }
    }
    Api.get('user/value', params).then(async response => {
      const { status, data } = response
      if (status === Constants.http.OK) {
        // console.log(data)
        // $store.state.sys.exchValue = data
        let combinedData = data
        const sgsptnk = $store.state.sys.exchanges.find((exch) => exch.sptnk === 'sg')
        if (sgsptnk) {
          try {
            const respsg = await Apis.sg.get('user/value', params)
            if (respsg.status === Constants.http.OK) {
              combinedData = {
                ...data,
                ...respsg.data
              }
              // $store.commit('setExchValue', combinedData)
            } else {
              // combinedData = data
              // $store.commit('setExchValue', data)
            }
          } catch (err) {
            console.log(err)
            // $store.commit('setExchValue', data)
          }
        }

        const getsptnk = $store.state.sys.exchanges.find((exch) => exch.sptnk === 'get')
        if (getsptnk) {
          try {
            const respsg = await Apis.get.get('user/value', params)
            if (respsg.status === Constants.http.OK) {
              combinedData = {
                ...combinedData,
                ...respsg.data
              }
              // $store.commit('setExchValue', combinedData2)
            } else {
              // $store.commit('setExchValue', combinedData)
            }
          } catch (err) {
            console.log(err)
            // $store.commit('setExchValue', combinedData)
          }
        }
        $store.commit('setExchValue', combinedData)
      } else {
        console.log('error. status: ', status)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  // depricated
  updateExchangesDepricated: function () {
    Api.get('user/info', {
      params: {
        token: $store.state.sys.token,
        demo: $store.state.sys.demo ? '1' : '0'
      }
    }).then(response => {
      const { status, data } = response
      if (status === Constants.http.OK) {
        $store.commit('setEmail', data.Email)
        $store.commit('setExchanges', data.exchanges)
      }
    }).catch(error => {
      console.log(error)
    })
  },
  selectTerminalSymbol (symbol) {
    if (
      !$store.state.trade.tvEnabled &&
      $store.state.trade.tvLoading
    ) {
      // console.log('tv not loaded. ignore symbol change')
      return
    }
    $store.state.trade.editTradeId = null
    $store.state.trade.editTrade = null
    // console.log('terminal: ', symbol)
    this.selectSymbol(symbol.replace('/', '_'))
  },
  selectSymbol (symbol) {
    // console.log('selectSymbol:', symbol)
    $store.state.trade.symbol = symbol
    if (!$store.state.sys.selSymbols) {
      $store.state.sys.selSymbols = {}
    }
    $store.state.sys.selSymbols[$store.state.sys.tradeExchange.Id] = symbol
    $store.state.sys.chartInfo = {
      ExchId: $store.state.sys.chartInfo.ExchId,
      TradeSymbol: symbol
    }
    localStorage.setItem('capico_app_selSymbols', JSON.stringify($store.state.sys.selSymbols))
  },
  cancelSearchOnEsc (vm, e) {
    if (e.keyCode === 27) {
      vm.symbolSearch = ''
      const elem = vm.$refs.searchText
      elem.blur()
    }
  },
  GetMarginLevel () {
    return Api.get('user/margin_level', {
      params: {
        token: $store.state.sys.token,
        etid: $store.state.sys.tradeExchange.Id
      }
    })
  },
  UpdateBalance () {
    return Apis[util.exchId2sputnik($store.state.sys.tradeExchange.ExchId)].get('user/update_balance', {
      params: {
        token: $store.state.sys.token,
        etid: $store.state.sys.tradeExchange.Id
      }
    })
  },
  createTpStep () {
    const trade = $store.state.trade.editTrade
    const priceDec = $store.state.data.symbolsfilter[$store.state.trade.symbol].PriceDec
    const qtyDec = $store.state.data.symbolsfilter[$store.state.trade.symbol].QtyDec
    const mult = trade.Side === 'B' ? 1.01 : 0.99
    let comparePrice = $store.state.sys.lastPrice
    let status = 'ACT'
    if (trade.Status === 'ORDSUBMIT' || trade.Status === 'COND') {
      comparePrice = trade.Price
      status = 'NEW'
    }
    const step = {
      Price: new Decimal(comparePrice).mul(mult).toDP(priceDec, Decimal.ROUND_DOWN).toString(),
      Pct: new Decimal(100).toString(),
      Qty: new Decimal(trade.Qty).toDP(qtyDec, Decimal.ROUND_DOWN).toString(),
      Status: status
    }
    step.Amount = new Decimal(step.Qty).mul(step.Price).toDP(qtyDec, Decimal.ROUND_DOWN).toString()

    if (trade.tpsteps) {
      trade.tpsteps.push(step)
    } else {
      Vue.set(trade, 'tpsteps', [step])
    }
    return step
  }
}
